import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 13 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m7.9 11.735 4.8-4.692a.93.93 0 0 0 0-1.37L7.2.298c-.3-.293-.7-.39-1.1-.195-.4.098-.6.489-.6.88v8.407L1.7 5.674a.98.98 0 0 0-1.4 0 .93.93 0 0 0 0 1.369l4.8 4.692-4.8 4.693a.93.93 0 0 0 0 1.368c.4.39 1 .39 1.4 0l3.8-3.715v8.408c0 .39.2.782.6.88.1.097.3.097.4.097.3 0 .5-.098.7-.293l5.5-5.377a.93.93 0 0 0 0-1.368zm-.4-8.407 3.1 3.03-3.1 3.03zm0 16.814v-6.06l3.1 3.03z"
    }, null, -1)
  ]))]))
}
export default { render: render }